import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { I18nPipe } from '../../i18n/i18n-pipe';
import { I18nScopeReadyDirective } from '../../i18n/i18n-scope-ready.directive';
import { provideI18nScope } from '../../i18n/i18n-scope.provider';
import { I18nScopedService } from '../../i18n/i18n-scoped.service';

export const UNSAVED_CHANGES_DIALOG_SCOPE =
  'shared/common/unsaved-changes-dialog';

/**
 * Optional overrides for the dialog text. All values must be pre-translated
 * strings — they are rendered as-is without passing through the i18n pipe.
 * Any field not provided falls back to the default translated text.
 */
export interface UnsavedChangesDialogData {
  title?: string;
  message?: string;
  stayButton?: string;
  discardButton?: string;
}

@Component({
  selector: 'app-unsaved-changes-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    I18nPipe,
    I18nScopeReadyDirective,
  ],
  providers: [
    provideI18nScope(UNSAVED_CHANGES_DIALOG_SCOPE),
    I18nScopedService,
  ],
  template: `
    <ng-container *appI18nScopeReady>
      <h2 mat-dialog-title>{{ data?.title || ('default.title' | i18n) }}</h2>
      <mat-dialog-content>
        <p>{{ data?.message || ('default.msg' | i18n) }}</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="stay()">
          {{ data?.stayButton || ('default.stay_btn' | i18n) }}
        </button>
        <button mat-flat-button color="warn" (click)="discard()">
          {{ data?.discardButton || ('default.discard_btn' | i18n) }}
        </button>
      </mat-dialog-actions>
    </ng-container>
  `,
})
export class UnsavedChangesDialog {
  private readonly dialogRef = inject(MatDialogRef<UnsavedChangesDialog>);
  readonly data = inject<UnsavedChangesDialogData>(MAT_DIALOG_DATA, {
    optional: true,
  });

  stay(): void {
    this.dialogRef.close(false);
  }

  discard(): void {
    this.dialogRef.close(true);
  }
}
